const POSSIBLE_PUBLISHER_ROLES: string[] = ['analyst', 'support_admin', 'combined'];

export const isSellerMode = (roles: Array<string> | undefined): boolean => {
  if (!roles) return false;

  return !roles.some((role) => POSSIBLE_PUBLISHER_ROLES.includes(role.toLowerCase())) && roles[0] === 'SELLER';
};
